export default __webpack_public_path__ + "static/media/Rectangle 998.b05e77d0.png";